import React, { Component, PropTypes } from 'react';
import s3functions from '../utils/s3Upload';

class ProfileImage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      options: [],
      profileImageStyle: {},
      profileImageBackgroundStyle: {},
    };
  }

  onChange = (event) => {
    let fileToUpload;
    if (event) {
      if (event.target.type === 'file') {
        // Make sure there are files
        if (event.target.files && event.target.files[0]) {
          // Make sure files are images
          if (event.target.files[0].type.match(/image.*/)) {
            const reader = new FileReader();
            reader.onloadend = () => {
              const image = new Image();
              image.src = reader.result;

              image.onload = () => {
                // Resize image
                // Check here to make sure no infinite loop of file reads;
                if (fileToUpload) {
                  return;
                }
                this.props.types.forEach(type => {
                  if (typeof type.onStart === 'function') {
                    type.onStart();
                  }
                  // upload regular and thumb
                  this.initUpload(image, type.maxSize, image, type);
                  this.initUpload(image, 256, image, {
                    maxSize: 256,
                    name: `${type.name}/thumb`,
                  });
                  fileToUpload = true;
                });
              };
            };
            reader.readAsDataURL(event.target.files[0]);
          } else {
            alert('Please upload a valid image!');
          }
        }
      }
    }
  };

  initUpload(image, maxSize, context, type) {
    const uploadImage = (file, fileName, callback) => {
      s3functions.s3upload({
        file_to_upload: file,
        file_name: fileName,
        onProgress(percent) {
          if (percent === 100) return;
        },
        onFinishS3Put(publicUrl) {
          // set profile IMG in preview box to new S3 URL;
          if (typeof callback === 'function') {
            callback(publicUrl);
          }
        },
        onError(status) {
          console.log(status);
        },
      });
    };
    const isCoverPhoto = (type.name === 'profileCover' || type.name === 'locationCover' || type.name === 'productCover');
    const resizedImage = isCoverPhoto ?
                        s3functions.resizeCoverImage(image, type.maxSize, context, type) :
                        s3functions.resizeImage(image, type.maxSize, context, type);
    const file = s3functions.dataURItoBlob(resizedImage, type);
    uploadImage(file, type.name, type.onChange);
  }

  render() {
    const { width, left, height, zIndex } = (this.props.style || {});

    const imageUploadStyle = {
      position: 'absolute',
      top: '0',
      cursor: 'pointer',
      bottom: '0',
      right: '0',
      opacity: '0',
      width,
      left,
      height,
      zIndex,
    };


    return (
      <div style={{ width: '100%' }}>
        <input onChange={this.onChange} type="file" style={imageUploadStyle} />
        {this.props.children}
      </div>
    );
  }
}

ProfileImage.propTypes = {
  types: PropTypes.array,
  style: PropTypes.object,
  children: PropTypes.any,
};

export default ProfileImage;



// WEBPACK FOOTER //
// ./src/app/components/image-upload.jsx